import { createListenerMiddleware } from "@reduxjs/toolkit";
import { addAuthListener } from "@/entities/session";

export const listenerMiddleware = createListenerMiddleware();

addAuthListener(listenerMiddleware.startListening);

export type AppStartListening = typeof listenerMiddleware.startListening;
